<template>
  <div class="wrapper">
    <dropzone-uploader
      v-if="validUpload"
      :uploadPath="uploadPath"
    />
  </div>
</template>

<script>
import {getManualUploadPage} from "@/api/api-project"
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import DropzoneUploader from '../components/Helpers/DropzoneUploader.vue'

export default {
  name: "ManualUpload",
  components: {DropzoneUploader},
  data() {
    return {
      uploadId: '',
      uploadPath: '',
      validUpload: false
    }
  },
  created() {
    this.uploadId = this.$route.params.id
    getManualUploadPage(this.uploadId)
      .then((res) => {
        if (res.data.data.status == 200) {
          this.uploadPath = res.data.data.path
          this.validUpload = true
        }
        if (res.data.data.status == 401) {
          this.$router.push('/401')
        }
        if (res.data.data.status == 404) {
          this.$router.push('/404')
        }
      })
  }
}
</script>

<style scoped>
  .wrapper {
    margin-top: 5rem;
    width: 70vw;
    margin-left: 15vw;
  }
</style>